import { LayoutGrid, LayoutList } from "lucide-react";

import { Card, CardContent, CardHeader, CardTitle } from "../../components/ui/card";
import { formatDate, getPreviewText } from "./formatters";
export default function TicketsView({ portal }) {
  const {
    clients: { selectedClientId },
    session: { user },
    tickets: {
      filteredTickets,
      kanbanColumns,
      openTicket,
      selectedTicketId,
      setTicketDisplayMode,
      ticketDisplayMode,
    },
    ui: { loadingData },
  } = portal;

  return (
    <Card className="support-content-card">
      <CardHeader>
        <div className="support-section-head">
          <CardTitle className="heading-2">
            {selectedClientId && user.role === "admin"
              ? "Tickets du client"
              : user.role === "developer"
                ? "Tickets attribués"
                : "Tickets recents"}
          </CardTitle>
          <div className="support-view-switch" role="tablist" aria-label="Mode d'affichage des tickets">
            <button
              type="button"
              className={`support-view-switch-btn ${ticketDisplayMode === "list" ? "is-active" : ""}`}
              onClick={() => setTicketDisplayMode("list")}
            >
              <LayoutList className="w-4 h-4" />
              Liste
            </button>
            <button
              type="button"
              className={`support-view-switch-btn ${ticketDisplayMode === "kanban" ? "is-active" : ""}`}
              onClick={() => setTicketDisplayMode("kanban")}
            >
              <LayoutGrid className="w-4 h-4" />
              Kanban
            </button>
          </div>
        </div>
      </CardHeader>
      <CardContent className="support-ticket-feed">
        {loadingData && <p className="caption">Chargement...</p>}
        {ticketDisplayMode === "list" &&
          filteredTickets.map((ticketItem) => (
            <button
              key={ticketItem.id}
              type="button"
              className={`support-ticket-row ${selectedTicketId === ticketItem.id ? "is-active" : ""}`}
              onClick={() => openTicket(ticketItem.id)}
            >
                <div className="support-ticket-row-head">
                  <strong>{ticketItem.ticket_number}</strong>
                  <span>{ticketItem.status_label}</span>
                </div>
                <p>{ticketItem.title}</p>
                <small>
                  {ticketItem.company_name} · Mis à jour le {formatDate(ticketItem.updated_at)}
                </small>
                {user.role !== "client" && ticketItem.assigned_developer_name && (
                  <small>Developpeur: {ticketItem.assigned_developer_name}</small>
                )}
                <small>{getPreviewText(ticketItem.description, 110)}</small>
              </button>
            ))}
        {ticketDisplayMode === "kanban" && (
          <div className="support-kanban-board">
            {kanbanColumns.map((column) => (
              <section key={column.value} className="support-kanban-column">
                <div className="support-kanban-column-head">
                  <strong>{column.label}</strong>
                  <span>{column.tickets.length}</span>
                </div>
                <div className="support-kanban-stack">
                  {column.tickets.map((ticketItem) => (
                    <button
                      key={ticketItem.id}
                      type="button"
                      className={`support-kanban-card ${selectedTicketId === ticketItem.id ? "is-active" : ""}`}
                      onClick={() => openTicket(ticketItem.id)}
                    >
                      <strong>{ticketItem.ticket_number}</strong>
                      <p>{ticketItem.title}</p>
                      <small>{getPreviewText(ticketItem.description, 90)}</small>
                      <small>{ticketItem.company_name}</small>
                      {user.role !== "client" && ticketItem.assigned_developer_name && (
                        <small>Dev: {ticketItem.assigned_developer_name}</small>
                      )}
                      <small>Maj le {formatDate(ticketItem.updated_at)}</small>
                    </button>
                  ))}
                  {column.tickets.length === 0 && (
                    <div className="support-kanban-empty">Aucun ticket</div>
                  )}
                </div>
              </section>
            ))}
          </div>
        )}
        {!loadingData && filteredTickets.length === 0 && (
          <p className="body-small">Aucun ticket a afficher.</p>
        )}
      </CardContent>
    </Card>
  );
}


